module.exports = __webpack_public_path__ + "img/sheduled.35e8d177.svg";